import { BaseContainer } from 'primsell-shared-layer/components'
import * as S from './success.styles'
import successIcon from 'primsell-shared-layer/assets/images/Tick.png'

interface ISuccessProps {
  text?: string
}

const Success = ({ text }: ISuccessProps): JSX.Element => {
  return (
    <BaseContainer>
      <S.Container>
        <img src={successIcon} alt="success" />
        <S.TitleTypography>Congratulations!</S.TitleTypography>
        <S.DetailsTypography color="grey">
          {text} <S.DetailsBr /> Please see more details on your mailbox.
        </S.DetailsTypography>
      </S.Container>
    </BaseContainer>
  )
}

export { Success }
